console.log('loaded apps module');

export { default } from './AppsModule';
